import Attachment from './src/attachment.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpAttachment = withInstall(Attachment)
export default EpAttachment
export * from './src/attachment'
